import { AppEnv } from '../../shared/appEnv';
import { FeatureToggleName, IFeatureToggle } from '../featureToggles.types';
import { extendDefaultFeatureToggles } from './default';

/** Local overrides. Anything not listed inherits the production value. */
const localOverrides: IFeatureToggle[] = [
    { name: FeatureToggleName.ExamplePilotFeature, isEnabled: true },
    { name: FeatureToggleName.Config_FeatureFlagCheckPage, isEnabled: true },
];

export const featureTogglesLocal = extendDefaultFeatureToggles(
    AppEnv.Local,
    localOverrides,
);
